export function getFixPath(path?: string): string | undefined {
    if (!path) {
        return path;
    }
    const matcher = path.match(/(.*)\/jcr:content$/);

    return !!matcher ? matcher[1] : path;
}
